const difficultyCodes = {
    'Easiest': 'Easiest',
    'Easy': 'Easy',
    'Moderate': 'MoreDiff',
    'Difficult': 'VeryDiff',
    'Extreme': 'ExtmDiff',
  };

const primaryTypeCodes = {
    'Hiking/Walking Trail': 'HikeWalk',
    'Hunting And/Or Fishing Access Trail': 'HuntFishAccess',
    'Mountain Biking Trail': 'MntnBike',
    'Motorized Trail': 'Motorized',
    'Multi-use (Walking, Running, Biking)': 'MultiUse',
    'Equestrian Trail': 'Equestrian',
    'Snowmobiling Trail': 'Snowmobile',
    'Cross-country Ski Trail': 'XCountrySki',
};

const activityTypeCodes = {
  'Hiking': 'PEDESTRIANS',
  'Walking': 'PEDESTRIANS',
  'Running': 'PEDESTRIANS',
  'Bicycling': 'BIKES',
  'Horses': 'HORSES',
  'APV <50"': 'APV_50',
  'APV <62"': 'APV_50_62',
  'APV >62"': 'APV_62',
  'Off-Road 4x4"': 'OFF_ROAD_4X4',
  'Snowmobiling': 'SNOWMOBILES',
  'Cross-Country Skiing': 'XC_SKIING',
};
  
const suitabilityTypeCodes = {
  'Dog Friendly': {field: 'DOGS', allowedValues:['Yes', 'Recmnd', 'Allow']},
  'Wheelchair Friendly': {field: 'WHEELCHAIR_FRIENDLY', allowedValues:['Yes', 'Recmnd', 'Allow']},
  'Boardwalk': {field: 'SURFACE', allowedValues:['Boardwlk']},
  'Paved': {field: 'SURFACE', allowedValues:['Paved']},
  'Gravel': {field: 'SURFACE', allowedValues:['Aggregt']},
  'E-Bikes': {field: 'E_BIKES', allowedValues:['Yes', 'Recmnd', 'Allow']},
};

export {difficultyCodes, primaryTypeCodes, activityTypeCodes, suitabilityTypeCodes};